import { render } from "./EscolaPerfilDeDados.vue?vue&type=template&id=47fd08ff&scoped=true&ts=true"
import script from "./EscolaPerfilDeDados.vue?vue&type=script&lang=ts"
export * from "./EscolaPerfilDeDados.vue?vue&type=script&lang=ts"

import "./EscolaPerfilDeDados.vue?vue&type=style&index=0&id=47fd08ff&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fd08ff"],['__file',"src/components/Escola/EscolaPerfilDeDados.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47fd08ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47fd08ff', __exports__)) {
    api.reload('47fd08ff', __exports__)
  }
  
  module.hot.accept("./EscolaPerfilDeDados.vue?vue&type=template&id=47fd08ff&scoped=true&ts=true", () => {
    api.rerender('47fd08ff', render)
  })

}


export default __exports__